import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"

const 回路図の支給形態 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { fileKbn: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="回路図の支給形態">
      <RadioGroup name={FIELD_NAMES.回路図の支給形態} selectedValue={values.fileKbn} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.回路図の支給形態["回路図＋ネットリスト"].value}>回路図＋ネットリスト</Radio>
          <Radio value={ESTIMATE_CONSTANT.回路図の支給形態.回路図.value}>回路図</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.fileKbn} />
    </OneClickField>
  )
}

export default 回路図の支給形態
